import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

interface RedeemedRecord {
  type: 'signature' | 'free-contract' | string & {}
  quantity: number
}

interface RedeemedCredit {
  description: string
}

export const useFetchCoupons = () => {
  const { post, get } = useFetchWithDefaults()

  const redeem = ({
    workspaceId,
    coupon,
  }: WorkspaceIdentifier & { coupon: string }) =>
    post<{ records?: Array<RedeemedRecord>, promotional_credits?: Array<RedeemedCredit> }>({
      url: '/me/coupons',
      workspaceId,
      fetchOptions: {
        body: {
          coupon,
        },
      },
    })

  const isRedeemed = ({
    workspaceId,
    coupon,
  }: WorkspaceIdentifier & { coupon: string }) =>
    get<{ is_redeemed: boolean }>({
      url: `/me/coupons/${coupon}/is-redeemed`,
      workspaceId,
    })

  return {
    redeem,
    isRedeemed,
  }
}
